import axios from "@/components/api/axios";

async function getCategoryParagraphList() {
  const res = await axios.axiosGet(
    "/api/fanClub/leaders/getCategoryParagraphList"
  );
  return res;
}

export default {
  getCategoryParagraphList
};



// WEBPACK FOOTER //
// ./src/components/api/fanClub/leaders/leadersTop.js